import { Card, Row } from "antd";
import "./CoachingCard.less";

const CoachingCard = (props) => {
  return (
    <Card className='coaching-card' loading={props.loading}>
      <Row justify='space-between' className='coaching-content'>
        <div span={12} className='coaching-centre-logo'>
          <img src={props.centrelogo} alt='institute logo' />
        </div>
        <div span={12} className='progress'>
          {props.present}/{props.totalclasses}
        </div>
      </Row>
    </Card>
  );
};

export default CoachingCard;
